import { render, staticRenderFns } from "./NavCartButton.vue?vue&type=template&id=62729c24"
import script from "./NavCartButton.vue?vue&type=script&lang=js"
export * from "./NavCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports